export const ALGOLIA_RULE_CONTEXT = {
  ONLY_PROTECTION: 'only_protection',
  WITHOUT_PROTECTION: 'without_protection',
  WITH_PROTECTION: 'with_protection',
  ONLY_ACCESSORY: 'only_accessory',
  ONLY_COMPATIBLE: 'only_compatible',
} as const

export type AlgoliaRuleContext =
  (typeof ALGOLIA_RULE_CONTEXT)[keyof typeof ALGOLIA_RULE_CONTEXT]

export type RuleContexts = readonly AlgoliaRuleContext[]

export const RECOMMENDATION_RULE_CONTEXTS = {
  CROSS_SELL: [
    ALGOLIA_RULE_CONTEXT.ONLY_ACCESSORY,
    ALGOLIA_RULE_CONTEXT.ONLY_COMPATIBLE,
    ALGOLIA_RULE_CONTEXT.WITH_PROTECTION,
  ] as const,

  CROSS_SELL_WITHOUT_PROTECTION: [
    ALGOLIA_RULE_CONTEXT.WITHOUT_PROTECTION,
    ALGOLIA_RULE_CONTEXT.ONLY_ACCESSORY,
    ALGOLIA_RULE_CONTEXT.ONLY_COMPATIBLE,
  ] as const,

  CROSS_SELL_ONLY_PROTECTION: [
    ALGOLIA_RULE_CONTEXT.ONLY_PROTECTION,
    ALGOLIA_RULE_CONTEXT.ONLY_ACCESSORY,
    ALGOLIA_RULE_CONTEXT.ONLY_COMPATIBLE,
    ALGOLIA_RULE_CONTEXT.WITH_PROTECTION,
  ] as const,
} as const
